import { EEntityType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { IGetFavoritesForDesktopResponseSchema } from '../../repositories/favorites/entities/get_favorites_for_desktop/GetFavoritesForDesktopResponseSchema';

export interface IFavoritesState {
  count: number;
  favoriteItems: IGetFavoritesForDesktopResponseSchema['favoriteEntities'];
  status: EFavoritesStatus;
  activeRequestId?: number;
}

export enum EFavoritesStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export { EEntityType as EFavoritesItemEntityType };
